import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid"; // استيراد DataGrid
import "../assets/css/ShipmentDetails.css";
import axios from "axios";
import {
  CircularProgress,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ShipmentDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const {
    shipmentDetails,
    shipmentTracking,
    shipmentComplaint,
    ComplaintsActions,
  } = location.state;
  const [complaintType, setComplaintType] = useState([]);
  const [formData, setFormData] = useState({
    TypeID: "",
    Email: "",
    Telephone: "",
    Details: "",
    AWB: shipmentDetails?.[0]?.AWB || "",
    Subject: "",
  });

  const [loading, setLoading] = useState(false); // إضافة حالة الـ Loading
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    // جلب أنواع الطلبات من API
    axios
      .get("https://tarabotcs.com-eg.net/api/Agent/V1/V1GetTiketTypes", {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        if (response.data && response.data.Data) {
          setComplaintType(response.data.Data); // استخدام فقط مصفوفة Data
        } else {
          setComplaintType([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching ticket types:", error);
        setComplaintType([]); // في حالة الخطأ قم بتحديد مصفوفة فارغة
      });
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleCloseModal = () => {
    setIsModalOpen(false); // إغلاق المودال
    navigate("/cs-home");
  };
  const handleSubmit = (e) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    e.preventDefault();
    setLoading(true); // تفعيل الـ Loading عند إرسال البيانات

    axios
      .post("https://tarabotcs.com-eg.net/api/Agent/V1/AddTicket", formData, {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        setLoading(false); // إخفاء الـ Loading بعد إرسال البيانات
        setIsModalOpen(true);
      })
      .catch((error) => {
        setLoading(false); // إخفاء الـ Loading بعد الفشل
        console.error("Error submitting complaint:", error);
        alert("Failed to submit complaint.");
      });
  };
  const complaintRows =
    Array.isArray(shipmentComplaint) && shipmentComplaint.length > 0
      ? shipmentComplaint.map((complaint, index) => ({
          id: index + 1,
          ComplaintDate: complaint?.ComplaintDate || "N/A",
          ComplaintType: complaint?.ComplaintType || "N/A",
          ComplaintSubject: complaint?.ComplaintSubject || "N/A",
          status: complaint?.ComplaintStatus || "N/A",
          details: complaint?.CompplaintDetails || "N/A",
        }))
      : [];
  const complaintColumns = [
    { field: "ComplaintDate", headerName: "Date", width: 200 },
    { field: "ComplaintType", headerName: "Call Type", width: 200 },
    { field: "status", headerName: "Status", width: 200 },
    { field: "ComplaintSubject", headerName: "Call Subject", width: 200 },
    { field: "details", headerName: "Call Details", flex: 1 },
  ];
  const supportRows =
    Array.isArray(ComplaintsActions) && ComplaintsActions.length > 0
      ? ComplaintsActions.map((complaint, index) => ({
          id: index + 1,
          serial: complaint?.ComplaintID || "N/A",
          ComplaintDate: complaint?.ActionDate || "N/A",
          status: complaint?.Status || "N/A",
          IsClosed: complaint?.IsClosed || "N/A",
          Notes: complaint?.Notes || "N/A",
        }))
      : [];

  const supportColumns = [
    { field: "serial", headerName: "ComplaintID", width: 150 },
    { field: "ComplaintDate", headerName: "Complaint Date", width: 200 },
    { field: "status", headerName: "Complaint Status", width: 150 },
    { field: "IsClosed", headerName: "Is Closed", width: 150 },
    { field: "Notes", headerName: "Notes", width: 150 },
  ];

  return (
    <div className="details-page">
      <div className="header">
        <h1>Shipment Info — AWB: {shipmentDetails?.[0]?.AWB || "N/A"}</h1>
        <button
          className="back-to-search-btn"
          onClick={() => navigate("/cs-home")}
          type="button"
        >
          {t("search") || "← Back to Search"}
        </button>
      </div>
      <div className="content">
        <div className="right-panel">
          <div className="shipment-info">
            <h2>Shipment Info</h2>
            <p>AWB Number: {shipmentDetails?.[0]?.AWB || "N/A"}</p>
            <p>Status : {shipmentDetails?.[0]?.StatusName || "N/A"}</p>
            <p>Runner : {shipmentDetails?.[0]?.RunnerName || ""}</p>
            <p>
              Pickup Date:{" "}
              {shipmentDetails?.[0]?.PickupDate
                ? new Date(shipmentDetails[0].PickupDate).toLocaleDateString()
                : ""}
            </p>
            <p>Notes: {shipmentDetails?.[0]?.SpecialInstruction || ""}</p>
          </div>
          <div className="sender-info">
            <h2>Shipper and Consignee Info</h2>
            <p>Consignee : {shipmentDetails?.[0]?.ConsigneeName}</p>
            <p>Address: {shipmentDetails?.[0]?.Address}</p>
            <p>Consignee Number: {shipmentDetails?.[0]?.Phone1}</p>
            <p>COD: {shipmentDetails?.[0]?.COD}</p>
            <p>Product: {shipmentDetails?.[0]?.Product}</p>
          </div>
        </div>
        <div className="left-panel">
          <h2>Shipment History</h2>
          <div className="tracking-list">
            {shipmentTracking?.length > 0 ? (
              shipmentTracking.map((track, index) => (
                <div key={index} className="tracking-item">
                  <p>{new Date(track.AuditDate).toLocaleString()}</p>
                  <p> {track.StatusName || "N/A"}</p>
                </div>
              ))
            ) : (
              <p>No tracking history available.</p>
            )}
          </div>
        </div>
      </div>

      {/* جدول الشكاوى */}
      <div className="complaints-section">
        <h2>Calls</h2>
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid
            rows={complaintRows}
            columns={complaintColumns}
            pageSize={5}
          />
        </div>
      </div>

      {/* جدول الدعم الفني */}
      <div className="support-section">
        <h2>Technical Support</h2>
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid rows={supportRows} columns={supportColumns} pageSize={5} />
        </div>
      </div>
      <div className="complaint-container">
        <div className="complaint-header">New Call</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Request Type</label>
            <select
              name="TypeID"
              value={formData.TypeID}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Request Type</option>
              {complaintType?.map((type) => (
                <option key={type.TypeID} value={type.TypeID}>
                  {type.EnglishNAme}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input
              type="text"
              name="Telephone"
              value={formData.Telephone}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="Email"
              value={formData.Email || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Subject</label>
            <input
              type="text"
              name="Subject"
              value={formData.Subject || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Details</label>
            <textarea
              name="Details"
              value={formData.Details}
              onChange={handleInputChange}
              required
            />
          </div>

          <button type="submit" className="btn-submit">
            {loading ? <CircularProgress size={24} /> : "Save"}
          </button>
        </form>
        <Dialog open={isModalOpen} onClose={handleCloseModal}>
          <DialogTitle>{t("shipmentSavedSuccessfully")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("shipmentSavedSuccessfully")}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleCloseModal}
              sx={{ backgroundColor: "#263150", color: "white" }}
            >
              {t("cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default ShipmentDetails;
